import {Button, Modal} from '@yandex-delivery/blocks'
import {useFormContext} from '@yandex-delivery/form'
import {useCallback} from 'react'

import {i18n} from 'src/shared/config'

import {ReturnPointForm} from './ReturnPointForm'
import * as classes from './ReturnPointModal.classes'
import type {Props} from './types'

export function ReturnPointModal(props: Props) {
  const {onClose, onAccept} = props
  const {trigger, isValidating} = useFormContext()

  const handleAccept = useCallback(async () => {
    const isValid = await trigger('returnPoint')

    if (isValid) {
      onAccept()
    }
  }, [onAccept, trigger])

  return (
    <Modal className={classes.root} data-e2e="return-point-modal" mx="s" onClose={onClose} opened>
      <Modal.Header title={i18n('cargo.create.return-point.requirement.modal-title', 'Адрес для возврата посылки')} />
      <Modal.Body>
        <ReturnPointForm />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <Button data-e2e="button-cancel" onPress={onClose} size="l">
            {i18n('cargo.create.due.button-cancel', 'Отменить')}
          </Button>
          <Button data-e2e="button-save" loading={isValidating} onPress={handleAccept} size="l" variant="action">
            {i18n('cargo.create.due.button-submit', 'Сохранить')}
          </Button>
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
}
